import { render, staticRenderFns } from "./AthleteComparativeDataView.vue?vue&type=template&id=4a376df6&"
import script from "./AthleteComparativeDataView.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports